import React,{useState,useContext} from 'react'
import Input from '../../components/Input/index.js'
import {Row,Col, Container, Alert} from 'react-bootstrap'
import {BsFillPersonFill} from 'react-icons/bs'
import {MdError} from 'react-icons/md'
import {HiBadgeCheck} from 'react-icons/hi'
import {IconContext} from 'react-icons'
import {AiFillSetting} from 'react-icons/ai'
import PrefixContext from "../../context/PrefixContext.js";
import AuthContext from '../../context/AuthContext.js'
import axios from 'axios'

function Index() {

    const AuthContextData = useContext(AuthContext);
    const PrefixContextData = useContext(PrefixContext);
    const defaultValidation = {
        validationStatus: null,
        validationStatusClass: null,
        validationStatusMessage: null,
        oldpassword:[],
        password:[],
        cpassword:[]
    }
    const [validation,setValidation] = useState(defaultValidation);
    const [data, setdata] = useState({
        oldpassword:"",
        password:"",
        cpassword:""
    })

    const resetPassword = async (e) => {
        e.preventDefault();
        if (validation.validationStatusClass === 'warning') return;
        setValidation({
            validationStatus: true,
            validationStatusClass:'warning',
            validationStatusMessage: 'Please wait updating ...',
            oldpassword:null,
            password:null,
            cpassword:null
        });
        await axios.post(PrefixContextData.prefixUrl + 'user/password', data)
        .then(response => {
            if(response.status === 200){
                setValidation({
                    validationStatus: true,
                    validationStatusClass:'success',
                    validationStatusMessage: response.data.successMessage,
                    oldpassword:null,
                    password:null,
                    cpassword:null
                });
            }
        })
        .catch(error => {
            if(error.response!==undefined){
                if(error.response.status === 401){
                    AuthContextData.logout()
                }
                else if(error.response !== undefined && error.response.data !== undefined && error.response.data.errorMessageDetails !== undefined ){
                    let errorDetails = {};
                    error.response.data.errorMessageDetails.forEach((e)=>{
                        errorDetails[e.param] = e.msg;
                    })
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.response.data.errorMessage,
                        oldpassword:(errorDetails.oldpassword !== undefined) ? errorDetails.oldpassword : null,
                        password:(errorDetails.password !== undefined) ? errorDetails.password : null,
                        cpassword:(errorDetails.cpassword !== undefined) ? errorDetails.cpassword : null,
                    });
                }
                else{
                    setValidation({
                    validationStatus: true,
                    validationStatusClass:'danger',
                    validationStatusMessage: error.message,
                    oldpassword: null,
                    password: null,
                    cpassword: null
                });
                }
            }
            else{
                setValidation({
                    validationStatus: true,
                    validationStatusClass:'danger',
                    validationStatusMessage: error.message,
                    oldpassword: null,
                    password: null,
                    cpassword: null
                });
            }
        });
    }
    
    const onChangeHandler = (e) =>{
        const newData = {
            ...data
        }
        newData[e.target.name]=e.target.value;
        setdata(newData);
    }


    return (
        <>
        <div className="new-section page-heading-margin bg-secondar d-flex">
            <Container className="mt-3 mt-md-4">
                    <Row>
                        <Col md="12" className="d-none" style={{maxWidth:'700px'}}>
                            <h5 className="mt-3 mt-md-3">
                                <IconContext.Provider value={{ color: "white", className: "global-class-name" }}>
                                    <div className="bg-primary d-inline-block p-2 mx-2 rounded">
                                        <BsFillPersonFill />
                                    </div>
                                </IconContext.Provider>
                                &nbsp;&nbsp; Profile
                            </h5>
                            <Row className="px-3">
                                <Col xs="3" md="3" className="align-self-center">
                                    <label htmlFor="email">Email</label>
                                </Col>
                                <Col xs="9" md="9">
                                    <Input type="text" disabled={true} defaultValue='pratikvora364@gmail.com' placeholder='Email'/>
                                </Col>
                            </Row>
                            <Row  className="px-3" style={{maxWidth:'700px'}}>
                                <Col xs="3" md="3" className="align-self-center">
                                    <label htmlFor="password">Password</label>
                                </Col>
                                <Col xs="9" md="9">
                                    <Input type="password" disabled={true} defaultValue='devbytes' placeholder='Email'/>
                                </Col>
                            </Row>
                        </Col>
                        <Col md="12" style={{maxWidth:'700px'}}>
                            <div>
                                <h5 className="mt-3 mt-md-3">
                                <IconContext.Provider value={{ color: "white", className: "global-class-name" }}>
                                    <div className="bg-primary d-inline-block p-2 mx-2 rounded">
                                        <AiFillSetting />
                                    </div>
                                </IconContext.Provider>
                                &nbsp;&nbsp; Change Password
                                </h5>
                                <div className="text-center">
                                    {validation.validationStatus === true && <Alert className="mb-0 d-inline-block" variant={validation.validationStatusClass}>
                                        {validation.validationStatusClass === 'success' && <HiBadgeCheck/>}
                                        {validation.validationStatusClass === 'danger' && <MdError/>}
                                        &nbsp;&nbsp; {validation.validationStatusMessage}
                                    </Alert>}
                                </div>
                                <form className="contactForm" onSubmit={(e)=>resetPassword(e)}>
                                    <Row className="px-3">
                                        <Col xs="3" md="3" className="align-self-center">
                                            <label htmlFor="email">Old Password</label>
                                        </Col>
                                        <Col xs="9" md="9">
                                            <Input type="password" name="oldpassword" onChangeHandler={onChangeHandler} validationError={validation.oldpassword}/>
                                        </Col>
                                    </Row>
                                    <Row  className="px-3" style={{maxWidth:'700px'}}>
                                        <Col xs="3" md="3" className="align-self-center">
                                            <label htmlFor="password">New Password</label>
                                        </Col>
                                        <Col xs="9" md="9">
                                            <Input type="password" name="password"  onChangeHandler={onChangeHandler} validationError={validation.password}/>
                                        </Col>
                                        <Col xs="3" md="3" className="align-self-center">
                                            <label htmlFor="password">Confirm New Password</label>
                                        </Col>
                                        <Col xs="9" md="9">
                                            <Input type="password" name="cpassword"  onChangeHandler={onChangeHandler} validationError={validation.cpassword}/>
                                        </Col>
                                        <Col>
                                            <div className="text-center">
                                                <button className="btn-primary mt-3" type="submit">Submit</button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                        </Col>
                    </Row>
            </Container>
        </div>
        </>
    )
}

export default Index
